import {
  Response,
  DateCodeInquiryCondition,
} from '../models/stock-summary-master.model';
import { MockService } from '../../../core/services/mock.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { delay, map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateCodeInquiryService {
  // 測試範例為了模擬資料查詢時間，實際開發不會用到
  delay: number = 1500;

  constructor(
    private readonly mockService: MockService,
    private readonly httpClient: HttpClient
  ) {}

  getDateCodeInquiry(
    condition: DateCodeInquiryCondition
  ): Observable<Response> {
    let endpoint = `${environment.apiEndpoint}/datecode-inquiry`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/datecode-inquiry.json'
    );
    if (environment.apiMock) {
      return this.httpClient.get<Response>(endpoint).pipe(
        map((data) => data),
        delay(this.delay)
      );
    }
    return this.httpClient.post<Response>(endpoint, condition);
  }
}
